import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { ScreeningState } from '../../../store/screening/screening.state';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-qc-steps',
  templateUrl: './qc-steps.component.html',
  styleUrls: ['./qc-steps.component.sass'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true, displayDefaultIndicatorType: false },
    },
  ],
})
export class CqStepsComponent implements OnInit {
  selectedStep = 0;
  isRepair = false;
  steps: string[] = [];

  // Mapeamento dinâmico para os labels
  stepLabels: { [key: string]: string } = {
    'imei': 'Validação de IMEI',
    'checklist': 'Checklist de Qualidade',
    'decision': 'Resultado da Avaliação',
  };

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _store: Store
  ) {}

  ngOnInit(): void {
    const state = this._store.selectSnapshot(ScreeningState);
    this.isRepair = !!state.isRepair;

    this.buildDynamicSteps();
    this.updateSelectedStep();
  }

  private buildDynamicSteps() {
    // Definimos que a primeira etapa é sempre 'imei'
    // A segunda etapa depende do isRepair
    const secondStepPath = this.isRepair ? 'checklist' : 'decision';

    this.steps = ['imei', secondStepPath];
  }

  private updateSelectedStep() {
    const urlSegments = this._router.url.split('/');
    const lastSegment = urlSegments[urlSegments.length - 1];

    // Encontra o índice baseado no path atual (imei, checklist ou decision)
    const index = this.steps.indexOf(lastSegment);
    this.selectedStep = index !== -1 ? index : 0;
  }

  stepperSelectionChanged(event: any) {
    this.selectedStep = event.selectedIndex;
    const path = this.steps[this.selectedStep];
    this._router.navigate([path], { relativeTo: this._route });
  }

  @HostListener('window:popstate')
  onPopState() {
    setTimeout(() => this.updateSelectedStep(), 0);
  }
}
